import { ProductDiscountValue } from '@commercetools/platform-sdk';
import { money } from '@nuts/auto-delivery-sdk/dist/utils/format';

import { PriceLike } from '@/lib/product/prices';
import { Money } from '@/utils/money';

export const getProductDiscountDisplayValue = (
  discountValue: ProductDiscountValue,
  quantity = 1,
): string | undefined => {
  if (discountValue.type === 'absolute') {
    return `${money(Money.multiply(discountValue.money[0], quantity))}`;
  }
  if (discountValue.type === 'relative') {
    return `${Math.round(discountValue.permyriad / 100)}%`;
  }
  return undefined;
};

export const getProductDiscountDisplayValueFromPrice = (price: PriceLike, quantity = 1) => {
  const discount = price.discounted?.discount;
  if (!discount) return undefined;

  const discountValue = 'value' in discount ? discount.value : discount.obj?.value;
  if (!discountValue) return undefined;

  return getProductDiscountDisplayValue(discountValue, quantity);
};
